<template>
  <q-btn
    :to="
      userUsageLimitReached
        ? undefined
        : { name: 'New Property Report', query: { propertyId: propertyId } }
    "
    :disable="userUsageLimitReached"
    dense
    unelevated
    color="primary"
    size="xs"
    style="margin-bottom: 5px"
  >
    <q-icon name="post_add" />
    <q-tooltip max-width="280px">
      {{ userUsageLimitReached ? userUsageHelpText : 'Create new report for this property' }}
    </q-tooltip>
  </q-btn>
</template>

<script lang="ts">
import { useUserStore } from '@/stores/user'

export default {
  name: 'NewPropertyReportIcon',
  props: {
    propertyId: {
      type: String,
      required: true
    }
  },
  computed: {
    userUsageLimitReached(): boolean {
      return useUserStore().userUsageLimitReached
    },
    userUsageHelpText(): string {
      return useUserStore().userUsageHelpText
    }
  }
}
</script>
